<template>
    <div>
        <div
            v-for="(linkGroup, index) in links"
            :key="index"
        >
            <div>
                <h2
                    v-if="!linkGroup[0].isSubTopic"
                    class="pageLink"
                >
                    <router-link
                        v-slot="{ href }"
                        :to="url(linkGroup[0])"
                        class="routerlink"
                        custom
                    >
                        <a
                            :href="href"
                            :class="[ 'navigation-font popuplink' ]"
                            :aria-current="false"
                            @click.self="navigate($event, linkGroup[0].url)"
                        >
                            {{ $t(linkGroup[0].textTerm) }}
                        </a>
                    </router-link>
                </h2>
                <ul v-if="linkGroup.length > 1">
                    <li
                        v-for="(link, linkIndex) in getsubLinks(linkGroup)"
                        :key="linkIndex"
                        role="menuitem"
                        class="subTopicLink"
                    >
                        <router-link
                            v-slot="{ href }"
                            :to="url(link)"
                            class="routerlink"
                            custom
                        >
                            <a
                                :href="href"
                                :class="[ 'navigation-font popuplink' ]"
                                :aria-current="false"
                                @click.self="navigate($event, link.url)"
                            >
                                {{ $t(link.textTerm) }}
                            </a>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"

    @Component
    export default class SivukarttaRouterLink extends Vue {
        @Prop({ type: Array<any> }) links!: Array<any>

        url(link): string {
            let url = link.to
            if (link.isSubTopic) {
                url += "?subTopic=" + link.subTopic
            }
            return url
        }

        getsubLinks(linkGroup) {
            const subLinks: any[] = []
            for (let i = 0; i < linkGroup.length; i++) {
                // Break if we encounter another header
                if (linkGroup[i].isSubTopic) {
                    subLinks.push(linkGroup[i])
                }
            }
            return subLinks
        }

        navigate(e, route) {
            this.$router.push(route)
            this.$emit("close")
        }
    }
</script>

<style scoped>
    .subTopicLink {
        margin-left: 10px;
    }
    .pageLink {
        margin-top: 20px;
    }
</style>
